export default __webpack_public_path__ + "static/media/dutchgot-screenshot-05.54882cf9.png";